<div class="bg-[#25508E] h-16  w-full flex px-3 justify-between"  style="position: relative;">

    <img  class="h-10 my-auto " src="assets/images/logo-whit-bg.svg"/>
    <p class="my-auto font-bold text-base  text-[#ffffff] " (click)="logout()"> 
        <img src="assets/images/logout.svg"/>
        log out 
    </p>

</div>
